import "./Insights.module.css";
import Navigation from "@/reusable_sections/Header";
import Thinking from "./sections/Thinking";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <Navigation />
      <Thinking />
      <Inquiries />
      <Footer />
    </div>;
}